export const questions = [
  {
    id: 1,
    questions: [
      {
        id: "profile",
        text: "Qual é o seu perfil?",
        options: [
          { id: "owner", text: "Dono do negócio" },
          { id: "partner", text: "Sócio" },
          { id: "financial", text: "Responsável financeiro" }
        ]
      },
      {
        id: "name",
        text: "Qual é o seu nome?",
        type: "text",
        placeholder: "Seu nome completo"
      },
      {
        id: "email",
        text: "Qual é o seu e-mail?",
        type: "email",
        placeholder: "seu@email.com"
      },
      {
        id: "phone",
        text: "Qual é o seu número de WhatsApp?",
        type: "phone",
        countryCode: "+55",
        placeholder: "(DDD) 9XXXX-XXXX"
      },
      {
        id: "company_size",
        text: "Qual é o tamanho da sua empresa?",
        options: [
          { id: "mei", text: "MEI" },
          { id: "small", text: "1 a 5 funcionários" },
          { id: "medium", text: "6 a 20 funcionários" },
          { id: "large", text: "Mais de 20 funcionários" }
        ]
      }
    ]
  },
  {
    id: 2,
    questions: [
      {
        id: "mix_accounts",
        text: "Hoje você mistura contas pessoais com as da empresa?",
        options: [
          { id: "always", text: "Sim, quase sempre" },
          { id: "sometimes", text: "Às vezes, sem querer" },
          { id: "never", text: "Não, nunca (sou organizado)" }
        ]
      },
      {
        id: "financial_control",
        text: "Como você faz o controle financeiro do seu negócio?",
        options: [
          { id: "bank", text: "Só pelo extrato bancário" },
          { id: "excel", text: "Planilha no Excel" },
          { id: "paper", text: "No papel/caderno" },
          { id: "accountant", text: "Peço para o contador" },
          { id: "system", text: "Já uso algum sistema" }
        ]
      },
      {
        id: "common_issues",
        text: "Já passou por essa situação?",
        options: [
          { id: "money_disappears", text: "Dinheiro entra, mas some sem saber para onde" },
          { id: "withdrawal_doubt", text: "Fico em dúvida se posso ou não retirar dinheiro da empresa" },
          { id: "supplier_payment", text: "Deixei de pagar fornecedor por erro de planejamento" },
          { id: "none", text: "Nenhuma dessas" }
        ]
      },
      {
        id: "cash_knowledge",
        text: "Você sabe exatamente quanto de caixa livre tem hoje?",
        options: [
          { id: "no_idea", text: "Não faço ideia" },
          { id: "more_or_less", text: "Mais ou menos, olhando o extrato" },
          { id: "yes_recorded", text: "Sim, tenho isso anotado/registrado" }
        ]
      }
    ]
  },
  {
    id: 3,
    questions: [
      {
        id: "want_solution",
        text: "Quer ver como resolver isso de forma simples?",
        type: "buttons",
        options: [
          { id: "yes", text: "Quero saber como" },
          { id: "no", text: "Não quero saber" }
        ]
      }
    ]
  },
  {
    id: 4,
    questions: [
      {
        id: "next_step",
        text: "Se suas finanças estivessem claras e sob controle, qual seria seu próximo passo?",
        options: [
          { id: "save", text: "Guardar mais lucro para mim" },
          { id: "invest", text: "Investir em crescimento/expansão" },
          { id: "reduce_debt", text: "Reduzir dívidas e ter paz" },
          { id: "organize_salary", text: "Organizar pró-labore/salário do dono" }
        ]
      }
    ]
  },
  {
    id: 5,
    questions: [
      {
        id: "separate_accounts",
        text: "Faz sentido que separar as contas pessoais das empresariais é o primeiro passo para o crescimento?",
        type: "buttons",
        options: [
          { id: "yes", text: "Sim, faz sentido" },
          { id: "no", text: "Não faz sentido" }
        ]
      },
      {
        id: "simple_tool",
        text: "Você acredita que teria mais tranquilidade se tivesse uma ferramenta simples para controlar fluxo de caixa, contas a pagar e receber, sem depender só do banco ou contador?",
        type: "buttons",
        options: [
          { id: "yes", text: "Sim, com certeza" },
          { id: "no", text: "Não faria diferença" }
        ]
      },
      {
        id: "start_today",
        text: "Gostaria de começar hoje mesmo a ter clareza sobre o dinheiro do seu negócio, com um passo a passo e uma ferramenta prática?",
        type: "buttons",
        options: [
          { id: "yes", text: "Sim, quero começar hoje" },
          { id: "no", text: "Prefiro deixar para depois" }
        ]
      }
    ]
  }
];
